import Head from "next/head";
import { useRouter } from "next/router";
export function Meta(props) {
  const { children, ...customMeta } = props;
  const { asPath } = useRouter();
  const meta = {
    title: "Axenda Drive",
    description: `Axenda Drive The place for ... .`,
    image: "https://axed.vercel.app/favicon-512.png",
    type: "website",
    ...customMeta,
  };
  return (
    <>
      <Head>
        <title>{meta.title}</title>
        <meta name="robots" content="follow, index" />
        <meta content={meta.description} name="description" />
        {/* og */}
        <meta property="og:url" content={`https://axed.vercel.app${asPath}`} />
        <meta property="og:type" content={meta.type} />
        <meta property="og:site_name" content="Axenda Drive" />
        <meta property="og:description" content={meta.description} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:image" content={meta.image} />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Axendateam" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:url" content={`https://axed.vercel.app${asPath}`} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={meta.image} />
      </Head>
      {children}
    </>
  );
}
